import { useState, useEffect } from 'react'
import { useParentRoute } from '@components/router/routes.js'
import { useHistory } from "react-router"
import { boldExportFile } from '@gUtils/downFile'
import { businessDataAPI, taskFlowAPI, sessionAPI } from '@api'
import { useSelector } from "react-redux";
import { checkAuth } from '@gUtils'
import { $error, Iconfont, $success, LazyLoadingImage } from "@/components";
import {
    notifySingleProduceScoreSubmit,
    resolveProduceScoreSubmitReason
} from '@/utils/produceScoreSubmitFeedback';
import { Table, Popover, Select } from 'antd'
import { summaryWeekColumn, summaryMonthColumn, emptyWeekColumns, emptyMonthColumns, useWindowSize, defaultTime } from './../config'
import { useTabsContext } from '@/layouts/barExtraContentLayout';
import BusinessDataKpiForm from './filterForm'
import ModifyScoreModal from './modify_score_modal'
import PreviewImage from '@components/image/preview_image'
import './../../index.less'

/**
 * 制作组周月统计
 * @returns {JSX.Element} ProductGroupNew
 */
const ProductGroupNew = () => {
    const route = useParentRoute()
    // 月度补分权限
    const permissions = 'update_supplement_score'
    const userPermissions = useSelector(state => state.session.permissions)
    const updateSupplementScore = checkAuth(userPermissions, permissions);
    const [dataList, setDataList] = useState([]); //列表数据
    const [loading, setLoading] = useState(true); // 列表loading
    const [btnLoading, setBtnLoading] = useState(false); // 导出按钮loading
    const [searchForm, setSearchForm] = useState({}); // pagination
    const [expandedRowKeys, setExpandedRowKeys] = useState([]); // 额外行key
    const [exportParams, setExportParams] = useState(); // 导出数据
    const [summaryData, setSummaryData] = useState([]); //合计栏数据
    const [isShowSummary, setIsShowSummary] = useState(true); //是否显示合计栏
    const [idealProcess, setIdealProcess] = useState([]); // 理想进度
    const [visible, setVisible] = useState(false); // 补分弹框
    const [supplyScoreRecord, setSupplyScoreRecord] = useState(); // 补分record
    const [unratedList, setUnratedList] = useState([]); // 未评分数据
    const [unratedLoading, setUnratedLoading] = useState(false);
    const [scoringTaskId, setScoringTaskId] = useState(null);
    const scrollHeight = useWindowSize()
    const [clientHeight, setClientHeight] = useState(800);
    const { calendarVisible } = useTabsContext(); // 关闭日历更新数据
    const history = useHistory()

    useEffect(() => {
        let setHeight = document.body.clientHeight > 800 ? document.body.clientHeight : 800
        setClientHeight(setHeight)
    }, [scrollHeight.width, scrollHeight.height]);

    useEffect(() => {
        if (searchForm.user_id) {
            setIsShowSummary(false)
            getUserListRequest()
        } else {
            setIsShowSummary(true)
            getGroupListRequest()
        }
        getUnratedListRequest()
        setExpandedRowKeys([])
    }, [searchForm, calendarVisible]);

    /**
     * 获取制作组 组列表
     * @returns {Object}
     */
    const getGroupListRequest = async () => {
        const { user_id, start_time = '', end_time = '' } = searchForm
        setLoading(true)
        let params = {
            start_time: Number(start_time || (route.key === "week" ? defaultTime.defaultStartWeek : defaultTime.defaultStartMonth)),
            end_time: Number(end_time || (route.key === "week" ? defaultTime.defaultEndWeek : defaultTime.defaultEndMonth)),
            user_id: user_id || 0,
            group_id: 0,
            is_month: route.key === "month" ? true : false,
            is_week: route.key === "week" ? true : false,
        }
        setExportParams(params);
        try {
            let res = await businessDataAPI.getGroupList(params)
            if (res.code === 1000) {
                setLoading(false)
                setIdealProcess(res.data.ideal_process)
                const expendList = res.data.infos.map((item) => {
                    return { ...item, parentLine: true }
                })
                res.data.summary['name'] = '合计'
                setSummaryData([res.data.summary])
                setDataList(expendList)
            } else {
                $error(res.mag);
            }
        } catch (err) { }
    }

    /**
     * 获取制作组 组员列表
     * @returns {Object}
     */
    const getUserListRequest = async (data) => {
        const { user_id, start_time = '', end_time = '' } = searchForm
        setLoading(true)
        const params = {
            start_time: Number(start_time || (route.key === "week" ? defaultTime.defaultStartWeek : defaultTime.defaultStartMonth)),
            end_time: Number(end_time || (route.key === "week" ? defaultTime.defaultEndWeek : defaultTime.defaultEndMonth)),
            user_id: user_id || 0,
            group_id: data?.group_id || 0,
            is_month: route.key === "month" ? true : false,
            is_week: route.key === "week" ? true : false,
        }
        setExportParams(params);
        try {
            let res = await businessDataAPI.getGroupUserList(params)
            if (res.code === 1000) {
                setLoading(false)
                if (user_id) {
                    setDataList(res.data.infos)
                } else {
                    const expendChildren = dataList?.map((item) => {
                        if (item.group_id === data.group_id) {
                            item["children"] = res.data.infos
                        }
                        return item
                    })
                    setDataList(expendChildren)
                }
            } else {
                $error(res.mag);
            }
        } catch (error) { }
    }

    /**
     * 获取未评分数据：与「未评分数据」页同口径（AMP status=18 且 difficulty=0）。
     */
    const getUnratedListRequest = async () => {
        setUnratedLoading(true)
        try {
            const res = await businessDataAPI.getProduceUnratedList({
                page: 1,
                page_size: 500,
                warehouse_stage: 'after_2025'
            })
            if (res.code !== 1000) {
                $error(res.msg || '获取未评分数据失败')
                return
            }
            setUnratedList(res.data?.infos || [])
        } catch (error) {
            $error(error.message || '获取未评分数据失败')
        } finally {
            setUnratedLoading(false)
        }
    }

    /**
     * 提交表单
     * @param {*} value
     */
    const submitForm = (value) => setSearchForm({ ...searchForm, ...value })

    /**
     * 重置表单
     */
    const resetForm = () => {
        setExpandedRowKeys([])
        setSearchForm({});
    };

    /**
     * 导出全部数据
     * @param {*} handleCsvRef
     */
    const csvExport = () => {
        setBtnLoading(true)
        businessDataAPI.exportWeekOrMonthSummary(exportParams).then((blob) => {
            setBtnLoading(false)
            boldExportFile(blob);
            $success('导出成功');
        }).catch((err) => {
            $error(err.message);
        });
    };

    /**
     * 跳转统计明细
     * @param {*} record
     */
    const handleDetail = (record) => {
        history.push({
            pathname: `/stats/business-data-overview/kpi/${route.key}-detail`,
            user_id: record?.user_id,
            group_id: record?.group_id,
            data: exportParams
        });
    }

    /**
     * 补分弹框
     */
    const handleUpdateScore = (record) => {
        setSupplyScoreRecord({
            user_id: record.user_id,
            time: exportParams?.start_time ? exportParams.start_time : defaultTime.defaultStartMonth
        })
        setVisible(true)
    }

    /**
     * 风险气泡内容
     * @returns {JSX.Element}
     */
    const content = (record) => {
        if (record.progress_rate >= idealProcess) {
            return <div>已达标，当前理想进度{idealProcess}%</div>
        }
        return <div>未达标，当前理想进度{idealProcess}%</div>
    }

    /**
    * 列表风险提示
    */
    const IdealProcess = {
        width: '4%',
        render: (_, record) => (
            <span className='cursor-pointer'>
                <Popover content={() => content(record)}>
                    {
                        record.progress_rate >= idealProcess ? <Iconfont type="icon-jinduzhengchang" /> : <Iconfont type="icon-jinduyichang" />
                    }
                </Popover>
            </span>
        )
    }

    // table columns
    const emptyClos = route.key === 'week' ? [...summaryWeekColumn, IdealProcess, ...emptyWeekColumns] : [...summaryMonthColumn, IdealProcess, ...emptyMonthColumns]
    const Clos = route.key === 'week' ? [...summaryWeekColumn, IdealProcess, {
        title: '操作',
        width: '10%',
        render: (record) => <span className="amp-blue-btn cursor-pointer" onClick={() => handleDetail(record)}>查看 </span>
    }] : [...summaryMonthColumn, IdealProcess, {
        title: '操作',
        width: '10%',
        render: (record) => (
            <>
                {updateSupplementScore && record.user_id > 0 && <span className="amp-blue-btn mg-r-22 cursor-pointer" onClick={() => handleUpdateScore(record)}>补分</span>}
                <span className="amp-blue-btn cursor-pointer" onClick={() => handleDetail(record)}> 查看 </span>
            </>
        )
    }]

    /**
     * antd 额外展开行
     * @param {*} expanded 是否展开
     * @param {*} record 行数据
     */
    const onExpand = (expanded, record) => {
        if (expanded) {
            getUserListRequest(record)
        }
    }
    const handleSetRowKey = (rowKeys) => setExpandedRowKeys(rowKeys)
    const expandedRowRender = (record) => <p key={record.group_id}></p>
    /**
     * 提交补分表单
     */
    const submitModalForm = () => {
        setVisible(false)
        setExpandedRowKeys([])
        getGroupListRequest()
    }
    const closeModal = () => setVisible(false)

    const onPreview = (src) => {
        if (!src) {
            return
        }
        PreviewImage.open({
            images: [src],
            request: (url) => sessionAPI.fetchOriginalImage(url).then((res) => res.data?.origin_urls?.[0] || '')
        })
    }

    const scoreOptions = Array.from({ length: 10 }, (_, idx) => ({
        label: `${idx + 1}`,
        value: idx + 1
    }))

    const handleScoreChange = async (score, record) => {
        setScoringTaskId(record.task_id)
        try {
            const res = await taskFlowAPI.updateProduceScore({
                id: record.task_id,
                action: 'update_produce_score',
                data: { score }
            })
            if (res.code !== 1000) {
                notifySingleProduceScoreSubmit({
                    ok: false,
                    reason: resolveProduceScoreSubmitReason(res, null, '提交失败')
                })
                return
            }
            notifySingleProduceScoreSubmit({ ok: true })
            setUnratedList((prev) => prev.filter((item) => item.task_id !== record.task_id))
            if (searchForm.user_id) {
                await getUserListRequest()
            } else {
                await getGroupListRequest()
            }
        } catch (error) {
            notifySingleProduceScoreSubmit({
                ok: false,
                reason: resolveProduceScoreSubmitReason(null, error, '提交失败')
            })
        } finally {
            setScoringTaskId(null)
        }
    }

    const unratedColumns = [
        {
            title: '预览图',
            dataIndex: 'preview_image',
            width: 90,
            render: (src) => (
                <LazyLoadingImage
                    preview={{ visible: false }}
                    onClick={(event) => {
                        event.stopPropagation()
                        onPreview(src)
                    }}
                    width="60px"
                    height="60px"
                    src={src}
                />
            )
        },
        {
            title: '资产ID',
            dataIndex: 'asset_no',
            render: (_, record) => record.asset_no || record.asset_uid || '-'
        },
        { title: '名称', dataIndex: 'asset_name' },
        {
            title: '入库时间',
            dataIndex: 'review_time',
            render: (_, record) => record.review_time || record.created_at || '-'
        },
        {
            title: '评分',
            dataIndex: 'score',
            width: 180,
            render: (_, record) => (
                <Select
                    placeholder="请选择评分"
                    options={scoreOptions}
                    style={{ width: 130 }}
                    onChange={(value) => handleScoreChange(value, record)}
                    loading={scoringTaskId === record.task_id}
                    disabled={scoringTaskId === record.task_id}
                />
            )
        }
    ]

    return (
        <div className='amps-business-data page-container'>
            <BusinessDataKpiForm
                submitForm={submitForm}
                resetForm={resetForm}
                csvExport={csvExport}
                btnLoading={btnLoading}
            />
            {
                visible && (
                    <ModifyScoreModal
                        visible={visible}
                        supplyScoreRecord={supplyScoreRecord}
                        closeModal={closeModal}
                        submitForm={submitModalForm}
                    />
                )
            }

            <Table
                scroll={{ y: clientHeight - 400 }}
                columns={Clos}
                dataSource={dataList}
                pagination={false}
                loading={loading}
                rowKey={(record) => record.group_id + record.user_id}
                rowExpandable={(record) => record.parentLine}
                expandedRowKeys={expandedRowKeys}
                onExpand={(expanded, record) => onExpand(expanded, record)}
                expandedRowRender={record => expandedRowRender(record)}
                onExpandedRowsChange={(rowKeys) => handleSetRowKey(rowKeys)}
            />
            <div className='mg-t-20'>
                <h3 className='mg-b-12'>未评分数据</h3>
                <Table
                    rowKey={(record) => record.task_id}
                    dataSource={unratedList}
                    columns={unratedColumns}
                    loading={unratedLoading}
                    pagination={{
                        position: ['bottomCenter'],
                        showQuickJumper: true,
                        showSizeChanger: false,
                        total: unratedList.length,
                        showTotal: (count) => `共 ${count} 条`,
                        pageSize: 10
                    }}
                />
            </div>
            {
                isShowSummary && (
                    <div className="amp-table-summary-no-thead">
                        <Table
                            scroll={{ y: clientHeight - 400 }}
                            showHeader={false}
                            columns={emptyClos}
                            pagination={false}
                            rowKey="group_id"
                            dataSource={summaryData}
                            expandedRowRender={record => expandedRowRender(record)}
                        />
                    </div>
                )
            }
        </div>
    )
}

export default ProductGroupNew
